import { render, staticRenderFns } from "./complaints.vue?vue&type=template&id=51306860&scoped=true"
import script from "./complaints.vue?vue&type=script&lang=js"
export * from "./complaints.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51306860",
  null
  
)

export default component.exports